//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MtSwitch from "~/components/form/MtSwitch";
import MtInput from "~/components/form/MtInput";
import Button from "~/components/other/Button";
import MtCheckbox from "~/components/form/MtCheckbox";
import GiftPatron from "~/components/forms/GiftPatron";
import { checkAllValues } from '~/utils/utils';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
// https://github.com/text-mask/text-mask/tree/master/addons/#createnumbermask - дока по собственным маскам
const numberMask = createNumberMask({
  prefix: '',
  //suffix: ' ₽', // почему то не дает стирать то, что написал, потом разобраться
  thousandsSeparatorSymbol: ' ',
  integerLimit: 8
})

const numberMaskCurrency = createNumberMask({
  prefix: '',
  suffix: ' ₽',
  thousandsSeparatorSymbol: ' ',
  integerLimit: 8
})

export default {
  components: {
    MtSwitch,
    MtInput,
    Button,
    MtCheckbox,
    GiftPatron
  },
  data() {
    return {
      showGiftForm: false,
      incognito: false,
      gift: false,
      policyChecked: false,
      offerChecked: false,
      offerError: false,
      policyError: false,
      otherSum: '',
      formError: null,
      inputValues: {
        name: '',
        surname: '',
        email: '',
        password: '',
        patronSumm: '5000'
      },
      validateValues: {
        name: this.$cookies.get('token') ? true : false,
        surname: this.$cookies.get('token') ? true : false,
        email: this.$cookies.get('token') ? true : false,
        password: this.$cookies.get('token') ? true : false,
        patronSumm: true
      },
      numberMask: numberMask,
      numberMaskCurrency: numberMaskCurrency
    }
  },
  computed: {
    checkAllValues() {
      return checkAllValues(this.validateValues, this.incognito)
    }
  },
  mounted() {
    if (this.$cookies.get('token')) {
      this.$axios({
        method: 'get',
        url: `/api/v1/personnel/get/?lang=${this.$i18n.locale || 'ru'}`,
      })
      .then(({data}) => {
        this.inputValues.name = data.data.name
        this.inputValues.surname = data.data.surname
      })
      .catch(err => {
        console.log('ошибка при загрузке данных', err)
      })
    }
  },
  methods: {
    validateForm() {
      const { name, surname, email, password, patronSumm } = this.inputValues
      this.policyError = false
      this.offerError = false
      this.formError = null

      if ((!this.policyChecked && !this.$cookies.get('token')) || !this.offerChecked) {
        this.policyError = !this.policyChecked
        this.offerError = !this.offerChecked
        return
      }
      // if (!this.policyChecked && !this.$cookies.get('token')) {
      //   this.policyError = !this.policyChecked
      //   return
      // }
      // if (!offerChecked) {
      //   this.offerError = !this.offerChecked
      // }
      if (!this.checkAllValues || Number(patronSumm) < 5000) {
        this.formError = this.$t('patronForm.formErrorMessage')
        return
      }

      if (this.$cookies.get('token')) {
        this.$axios({method: 'get', url: `/api/v1/personnel/get/?lang=${this.$i18n.locale || 'ru'}`})
          .then(({data}) => {
            this.inputValues.email = data.data.email

            if (this.gift) {
              this.showGiftForm = true
              this.$store.commit('forms/openGetPatronMasterpieceStepTwo')
            } else {
              this.getPaymentForm()
            }
          })
      } else {
        this.authorizationAttempt()
      }
    },
    getPaymentForm(giftEmail) {
      const { name, surname, email, password, patronSumm } = this.inputValues
      let text = `lang=${this.$i18n.locale || 'ru'}&customPrice=${patronSumm}&email=${email}&anonymous=${this.incognito}&itemId=${this.$store.getters['forms/getPatronMasterpiece'].id}&isGift=${this.gift}`

      if (!this.incognito) {
        text += `&name=${name}&surname=${surname}`
      }
      if (this.gift) {
         text += `&giftRecipientEmail=${giftEmail}`
      }
      this.$axios({
        method: 'post',
        url: '/api/v1/patronage/add',
        data: text
      })
        .then(({data}) => {
          window.location.href = data.data.gpbPaymentUrl
        })
        .catch(err => {
          console.log('ошибка при запросе на донат', err)
        })
    },
    authorizationAttempt() {
      const { name, surname, email, password } = this.inputValues

      this.$axios({
        method: 'post',
        url: '/api/auth/',
        data: `email=${email}&password=${password}&lang=${this.$i18n.locale || 'ru'}`
      })
        .then(({data}) => {
          if (!data.error) {
            this.$cookies.set('token', data.data.token)
            this.$axios.setHeader('Authorization-token', `REST:${data.data.token}`)
            this.$store.commit('changeNeedUpdatePhoto', true)
            if (this.gift) {
              this.showGiftForm = true
            } else {
              this.getPaymentForm()
            }
          } else {
            this.$axios({
              method: 'post',
              url: '/api/register/',
              data: `lang=${this.$i18n.locale || 'ru'}&email=${email}&password=${password}&name=${name[0].toUpperCase() + name.slice(1)}&surname=${surname[0].toUpperCase() + surname.slice(1)}`
            })
              .then(({data}) => {
                if (data.error) {
                  this.formError = data.error.message
                } else {
                  this.$cookies.set('token', data.data.token)
                  this.$axios.setHeader('Authorization-token', `REST:${data.data.token}`)
                  if (this.gift) {
                    this.showGiftForm = true
                  } else {
                    this.getPaymentForm()
                  }
                }
              })
          }
        })
        .catch(err => {

        })
    }
  }
}
